import i18next from 'i18next';
import en from './navigation-i18n/en';
import tw from './navigation-i18n/tw';
import ch from './navigation-i18n/ch';

i18next.addResourceBundle('en', 'navigation', en);
i18next.addResourceBundle('tw', 'navigation', tw);
i18next.addResourceBundle('ch', 'navigation', ch);

const navigationConfig = [
	{
		id: 'home',
		title: 'Home',
		translate: 'HOME',
		type: 'item',
		icon: 'home_work',
		url: '/home'
	},
	{
		id: 'products',
		title: 'Products',
		translate: 'PRODUCTS',
		type: 'item',
		icon: 'construction',
		url: '/products'
	},
	{
		id: 'iso',
		title: 'ISO 9001',
		translate: 'ISO',
		type: 'item',
		icon: 'verified_user',
		url: '/iso-9001'
	},
	{
		id: 'minerals',
		title: 'Responsible Minerals',
		translate: 'MINERALS',
		type: 'item',
		icon: 'verified',
		url: '/responsible-minerals'
	},
	{
		id: 'contact',
		title: 'Contact',
		translate: 'CONTACT',
		type: 'item',
		icon: 'contact_page',
		url: '/contact'
	}
];

export default navigationConfig;
